var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-card",
                { attrs: { shadow: "never" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                        "align-items": "center",
                      },
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _c("span", [_vm._v("组织机构")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c("el-button", {
                            staticStyle: { float: "right" },
                            attrs: {
                              size: "mini",
                              icon: "el-icon-refresh",
                              circle: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.getDeptTreeList()
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("el-button", {
                            staticStyle: { float: "right" },
                            attrs: {
                              size: "mini",
                              icon: "el-icon-edit",
                              circle: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.toDeptView()
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("el-tree", {
                    attrs: {
                      data: _vm.deptTree,
                      "node-key": "id",
                      "default-expand-all": "",
                      "expand-on-click-node": false,
                      props: { children: "children", label: "name" },
                    },
                    on: { "node-click": _vm.handleNodeClick },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { staticStyle: { "padding-left": "20px" }, attrs: { span: 20 } },
            [
              _c(
                "el-form",
                {
                  ref: "queryParams",
                  attrs: {
                    model: _vm.queryParams,
                    inline: "",
                    "label-width": "60px",
                    "label-position": "left",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "用户名" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          clearable: "",
                          placeholder: "请输入用户名",
                        },
                        model: {
                          value: _vm.queryParams.username,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParams, "username", $$v)
                          },
                          expression: "queryParams.username",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "昵称" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          clearable: "",
                          placeholder: "请输入昵称",
                        },
                        model: {
                          value: _vm.queryParams.nickName,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParams, "nickName", $$v)
                          },
                          expression: "queryParams.nickName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { "label-width": "0px" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { icon: "el-icon-search", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.refresh()
                            },
                          },
                        },
                        [_vm._v("查询")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { icon: "el-icon-refresh", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.reset()
                            },
                          },
                        },
                        [_vm._v("重置")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: ["user:save"],
                              expression: "['user:save']",
                            },
                          ],
                          attrs: { icon: "el-icon-plus", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.addUser()
                            },
                          },
                        },
                        [_vm._v("添加")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: ["user:delete"],
                              expression: "['user:delete']",
                            },
                          ],
                          attrs: {
                            icon: "el-icon-delete",
                            type: "primary",
                            disabled: _vm.delBtnDisabled,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.removeBatch()
                            },
                          },
                        },
                        [_vm._v("删除\n          ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("table-page", {
                ref: "tablePage",
                attrs: {
                  url: _vm.tableUrl,
                  columns: _vm.columns,
                  "query-params": _vm.queryParams,
                },
                on: { "table-select-val": _vm.selectVal },
                scopedSlots: _vm._u([
                  {
                    key: "sex",
                    fn: function (ref) {
                      var row = ref.row
                      return _vm._l(_vm.sexOptionList, function (item) {
                        return row.sex === item.dictValue
                          ? _c("el-tag", { attrs: { type: item.listClass } }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(item.dictLabel) +
                                  "\n          "
                              ),
                            ])
                          : _vm._e()
                      })
                    },
                  },
                  {
                    key: "userStatus",
                    fn: function (ref) {
                      var row = ref.row
                      return _vm._l(_vm.statusOptionList, function (item) {
                        return row.userStatus === item.dictValue
                          ? _c("el-tag", { attrs: { type: item.listClass } }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(item.dictLabel) +
                                  "\n          "
                              ),
                            ])
                          : _vm._e()
                      })
                    },
                  },
                  {
                    key: "action",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: ["user:update"],
                                expression: "['user:update']",
                              },
                            ],
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.update(row)
                              },
                            },
                          },
                          [_vm._v("修改")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: ["user:delete"],
                                expression: "['user:delete']",
                              },
                            ],
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.remove(row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: ["user:reset:pass"],
                                expression: "['user:reset:pass']",
                              },
                            ],
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.resetPassword(row)
                              },
                            },
                          },
                          [_vm._v("重置密码")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: ["user:auth:role"],
                                expression: "['user:auth:role']",
                              },
                            ],
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.authRole(row)
                              },
                            },
                          },
                          [_vm._v("授权角色")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.dialogShow
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: _vm.dialogTitle,
                visible: _vm.dialogShow,
                "close-on-click-modal": false,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogShow = $event
                },
                close: function ($event) {
                  return _vm.handleReset("form")
                },
              },
            },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-width": "80px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "部门", prop: "deptId" } },
                    [
                      _c("vue-treeselect", {
                        attrs: {
                          options: _vm.deptTree,
                          placeholder: "请选择部门",
                          normalizer: _vm.normalizer,
                        },
                        on: {
                          input: function ($event) {
                            return _vm.change($event)
                          },
                        },
                        model: {
                          value: _vm.form.deptId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "deptId", $$v)
                          },
                          expression: "form.deptId",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "用户名", prop: "username" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入用户名" },
                                model: {
                                  value: _vm.form.username,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "username", $$v)
                                  },
                                  expression: "form.username",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "昵称", prop: "nickName" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入昵称" },
                                model: {
                                  value: _vm.form.nickName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "nickName", $$v)
                                  },
                                  expression: "form.nickName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.dialogTitle === "添加用户"
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "密码", prop: "password" } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入密码",
                                      "show-password": "",
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.change($event)
                                      },
                                    },
                                    model: {
                                      value: _vm.form.password,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "password", $$v)
                                      },
                                      expression: "form.password",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.dialogTitle === "添加用户"
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "确认密码",
                                    prop: "passwordCheck",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入确认密码",
                                      "show-password": "",
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.change($event)
                                      },
                                    },
                                    model: {
                                      value: _vm.form.passwordCheck,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "passwordCheck", $$v)
                                      },
                                      expression: "form.passwordCheck",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "性别", prop: "sex" } },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.form.sex,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "sex", $$v)
                                    },
                                    expression: "form.sex",
                                  },
                                },
                                [
                                  _vm._l(_vm.sexOptionList, function (item) {
                                    return [
                                      _c(
                                        "el-radio",
                                        { attrs: { label: item.dictValue } },
                                        [_vm._v(_vm._s(item.dictLabel))]
                                      ),
                                    ]
                                  }),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "状态", prop: "userStatus" } },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.form.userStatus,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "userStatus", $$v)
                                    },
                                    expression: "form.userStatus",
                                  },
                                },
                                [
                                  _vm._l(_vm.statusOptionList, function (item) {
                                    return [
                                      _c(
                                        "el-radio",
                                        { attrs: { label: item.dictValue } },
                                        [_vm._v(_vm._s(item.dictLabel))]
                                      ),
                                    ]
                                  }),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "邮箱", prop: "email" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入邮箱" },
                                model: {
                                  value: _vm.form.email,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "email", $$v)
                                  },
                                  expression: "form.email",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "手机号", prop: "phoneNumber" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入手机号" },
                                model: {
                                  value: _vm.form.phoneNumber,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "phoneNumber", $$v)
                                  },
                                  expression: "form.phoneNumber",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "岗位", prop: "postIds" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { multiple: "", placeholder: "请输入岗位" },
                          on: {
                            input: function ($event) {
                              return _vm.change($event)
                            },
                          },
                          model: {
                            value: _vm.form.postIds,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "postIds", $$v)
                            },
                            expression: "form.postIds",
                          },
                        },
                        _vm._l(_vm.postList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.postName, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.handleReset("form")
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.handleSubmit("form")
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "授权角色",
            visible: _vm.dialogAuthRoleShow,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogAuthRoleShow = $event
            },
          },
        },
        [
          _vm.dialogAuthRoleShow
            ? _c("el-transfer", {
                attrs: {
                  filterable: "",
                  "filter-method": _vm.filterMethod,
                  titles: ["角色列表", "已授权角色"],
                  data: _vm.roleList,
                },
                model: {
                  value: _vm.targetKeys,
                  callback: function ($$v) {
                    _vm.targetKeys = $$v
                  },
                  expression: "targetKeys",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.cancelAuthRoleDialog()
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.saveAuthRole()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }